import React from 'react';
import { SegmentedControl } from '../ui/surface';

export const schoolTimeRanges = (t) => [
  { id: '30m', label: t('trafficOverview.timeRange30m') },
  { id: '6h', label: t('trafficOverview.timeRange6h') },
  { id: '24h', label: t('trafficOverview.timeRange24h') },
  { id: '7d', label: t('trafficOverview.timeRange7d') },
  { id: '30d', label: t('trafficOverview.timeRange30d') },
];

const RangeSwitch = ({ ranges, value, onChange }) => (
  <SegmentedControl options={ranges} value={value} onChange={onChange} />
);

export default RangeSwitch;
